module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-side-cjdr.0748d7d4.png";